import firebase from "firebase";
import 'firebase/messaging';
import "firebase/analytics";

const config = {
    apiKey: "AIzaSyDHDQcc2D8jhHwpUTpV06c2llSmRFRvypM",
    authDomain: "genba-next.firebaseapp.com",
    databaseURL: "https://genba-next.firebaseio.com",
    projectId: "genba-next",
    storageBucket: "genba-next.appspot.com",
    messagingSenderId: "663843998838",
    appId: "1:663843998838:web:c64ae964c64b56e1b02357",
    measurementId: "G-70KB4CY77T"
};

firebase.initializeApp(config);
let messaging = null;
try {
    messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
} catch (error) {
    console.log(`error`, error);
}
// Initialize Analytics and get a reference to the service
export const analytics = firebase.analytics();

export const getToken = (setTokenFound) => {
    // const messaging = firebase.messaging();
    return messaging?.getToken({ vapidKey: 'BM6WNmQzo_rAsx0jbfnCN7RxNBGa35J61vv8GCOzZSb-bsZcMCdPQLrsdQZpSNPsuJiMp3x483iLcojPhW9_29E' }).then((currentToken) => {
        if (currentToken) {
            localStorage.setItem('FCMToken', currentToken)
            setTokenFound(true);
            return currentToken
        } else {
            console.log('No registration token available. Request permission to generate one.');
            setTokenFound(false);
            return false
        }
    }).catch((err) => {
        // console.log('An error occurred while retrieving token. ', err);
    });
}

// export const onMessageListener = () =>
//     new Promise((resolve) => {
//         messaging.onMessage((payload) => {
//             resolve(payload)
//         });
//     });

export default firebase;
